'use client';

import { Carousel } from '@/components/carousel';
import { api } from '@/server/callers/client';
import TestmonialCard from './testmonial-card';

export default function TestimonialsSection() {
  const testimonials = api.testimonials.list.useQuery();

  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div data-aos="fade-up" className="text-center mb-16">
          <h2 className="font-outfit text-4xl md:text-6xl font-medium leading-[120%] tracking-[-1.5px] text-center text-[#161618]">
            Backed by 100+ Real Reviews
          </h2>
          <p className="font-outfit text-lg font-light leading-[1.64em] tracking-[-0.2px] text-center text-[#56575c]">
            Read what our travelers have to say about their experiences with Enlil.
          </p>
        </div>

        <Carousel
          className="w-full"
          options={{ loop: true, align: 'center' }}
          autoplay={true}
        >
          {testimonials.data?.map((testimonial) => (
            <TestmonialCard
              key={testimonial.id}
              testimonial={testimonial}
              className="mx-2"
            />
          ))}
        </Carousel>
      </div>
    </section>
  );
}
